<template>
    <div>
        <Toast
            :show.sync="toast.show"
            :message="toast.message"
            :tipe="toast.tipe"
            @close="toast.show = false"
            :position="toast.position"
            :icon="toast.icon"
        ></Toast>
        <loading
            :active.sync="loading.app"
            :can-cancel="false"
            :is-full-page="true"
            :color="'#0B8BCC'"
            :loader="'dots'"
            :opacity="0.7"
            :lock-scroll="true"
        ></loading>
        <!-- App Header -->
        <div class="appHeader bg-primary text-light">
            <div class="pageTitle">Akun Saya</div>
            <!-- <div class="right">
                <a class="headerButton" @click="showDialog('show')">
                    <ion-icon name="log-out-outline"></ion-icon>
                </a>
            </div> -->
        </div>
        <!-- * App Header -->

        <!-- App Capsule -->
        <div id="appCapsule" v-if="loading.app == false">
            <div
                class="section detail-transaction-section pt-2"
                style="--height: 60px"
            >
                <div class="detail-card text-center">
                    <h3 class="mt-1 mb-0">
                        <span>{{ customer.name }}</span>
                        <img
                            :src="require('@/assets/verified.png')"
                            alt="image"
                            class="image"
                            style="height: 25px; margin-left: 2px"
                            v-if="
                                customer.account_verified_data &&
                                customer.account_verified_data.status ==
                                    'APPROVED'
                            "
                        />
                        <img
                            :src="require('@/assets/unverified.png')"
                            alt="image"
                            class="image"
                            style="height: 25px; margin-left: 2px"
                            v-else
                        />
                    </h3>
                    <p class="mb-0" v-if="customer.role == 'Member'">
                        Mitra Personal
                    </p>
                    <p class="mb-0" v-else-if="customer.role == 'Premium'">
                        Mitra Premium
                    </p>
                    <p class="mb-0" v-else-if="customer.role == 'Bisnis'">
                        Mitra Bisnis
                    </p>
                    <p class="mb-0" v-else-if="customer.role == 'H2H'">
                        Host To Host (H2H)
                    </p>
                    <p class="mb-0" v-else-if="customer.role == 'MD'">
                        Master Dealer
                    </p>
                    <!-- <hr style="margin: 10px 0px 10px 0px;">
                    <div class="balance mb-1">
                        <div class="col-6 text-left">
                            <span class="title">Saldo Anda</span>
                            <h1 class="total" :class="{'loading-component': loading.content}"><span>Rp {{ customer.balance | rupiah }}</span></h1>
                        </div>
                        <div class="col-6 text-right">
                            <span class="title">Komisi Anda</span>
                            <h1 class="total" :class="{'loading-component': loading.content}"><span>Rp {{ customer.komisi | rupiah }}</span></h1>
                        </div>
                    </div> -->
                </div>
            </div>
            <!-- <div class="section mt-2" v-if="customer.role == 'Member'">
                <router-link :to="{name: 'account.upgrade'}" class="btn btn-primary btn-block btn-lg">
                    <ion-icon name="diamond"></ion-icon> Upgrade Premium
                </router-link>
            </div> -->
            <!-- <div class="section full mt-1">
                <div class="listview-title pl-3 pr-3" style="font-weight:bold;">Fitur Tambahan</div>
                <ul class="listview image-listview inset">
                    <li>
                        <a href="Javascript:;" class="item" @click="coming()">
                            <div class="icon-box bg-primary">
                                <ion-icon name="receipt"></ion-icon>
                            </div>
                            <div class="in">
                                <div>Rekap Transaksi</div>
                            </div>
                        </a>
                    </li>
                    <li>
                        <a href="Javascript:;" class="item" @click="coming()">
                            <div class="icon-box bg-primary">
                                <ion-icon name="fitness"></ion-icon>
                            </div>
                            <div class="in">
                                <div>Sedekah</div>
                            </div>
                        </a>
                    </li>
                    <li>
                        <a href="Javascript:;" class="item" @click="coming()">
                            <div class="icon-box bg-primary">
                                <ion-icon name="ticket"></ion-icon>
                            </div>
                            <div class="in">
                                <div>Redeem Voucher</div>
                            </div>
                        </a>
                    </li>
                </ul>
            </div> -->
            <div
                class="section mt-2"
                v-if="
                    !customer.account_verified_data ||
                    customer.account_verified_data.status != 'APPROVED'
                "
            >
                <div class="goals">
                    <!-- item -->
                    <div
                        class="item"
                        style="cursor: pointer"
                        @click="GoToVerified()"
                    >
                        <div class="in mb-0">
                            <div>
                                <h4 style="margin-bottom: 2px">
                                    Verifikasi Data Anda
                                </h4>
                                <p>
                                    Status :
                                    <label
                                        class="text-secondary mb-0"
                                        v-if="!customer.account_verified_data"
                                        >Belum Lengkap</label
                                    >
                                    <label
                                        class="text-danger mb-0"
                                        v-else-if="
                                            customer.account_verified_data
                                                .status == 'REJECTED'
                                        "
                                        >Verifikasi ditolak</label
                                    >
                                    <label
                                        class="text-warning mb-0"
                                        v-else-if="
                                            customer.account_verified_data
                                                .status == 'PROCESS'
                                        "
                                        >Dalam proses</label
                                    >
                                    <label
                                        class="text-success mb-0"
                                        v-else-if="
                                            customer.account_verified_data
                                                .status == 'APPROVED'
                                        "
                                        >Terverifikasi</label
                                    >
                                    <label class="text-secondary mb-0" v-else
                                        >Belum Lengkap</label
                                    >
                                </p>
                            </div>
                            <div
                                class="text-primary text-nowrap"
                                style="font-size: 13px"
                            >
                                Lihat Detail
                                <ion-icon name="chevron-forward"></ion-icon>
                            </div>
                        </div>
                    </div>
                    <!-- * item -->
                </div>
            </div>
            <div class="section full mt-1">
                <div
                    class="listview-title pl-3 pr-3"
                    style="font-weight: bold; font-size: 16px"
                >
                    Informasi
                </div>
                <ul class="listview image-listview inset">
                    <li>
                        <router-link
                            :to="{ name: 'account.profile' }"
                            class="item"
                        >
                            <div class="in">
                                <div class="text-nowrap">Info Profil</div>
                                <div
                                    class="badge badge-grey-custom pl-1"
                                    style="padding-right: 2px"
                                    v-if="!customer.customer_detail"
                                >
                                    <span
                                        style="
                                            font-size: 11px;
                                            margin-right: 3px;
                                        "
                                        >Belum lengkap</span
                                    >
                                </div>
                            </div>
                        </router-link>
                    </li>
                    <li>
                        <router-link
                            :to="{ name: 'account.business' }"
                            class="item"
                        >
                            <div class="in">
                                <div>Info Usaha</div>
                                <div
                                    class="badge badge-grey-custom pl-1"
                                    style="padding-right: 2px"
                                >
                                    <span
                                        style="
                                            font-size: 11px;
                                            margin-right: 3px;
                                        "
                                        v-if="!customer.customer_business"
                                        >Belum lengkap</span
                                    >
                                </div>
                            </div>
                        </router-link>
                    </li>
                    <!-- <li>
                        <router-link :to="{name:'account.developer'}" class="item pl-3 pr-5">
                            <div>Developer H2H</div>
                        </router-link>
                    </li> -->
                </ul>
            </div>
            <div class="section full mt-1">
                <div
                    class="listview-title pl-3 pr-3"
                    style="font-weight: bold; font-size: 16px"
                >
                    Pengaturan
                </div>
                <ul class="listview image-listview inset">
                    <li>
                        <router-link
                            :to="{ name: 'account.struk' }"
                            class="item"
                        >
                            <div class="in">
                                <div>Struk</div>
                                <!-- <span class="badge badge-success pr-2 pl-2">Fitur Baru</span> -->
                            </div>
                        </router-link>
                    </li>
                    <!-- <li>
                        <router-link :to="{name:'account.developer'}" class="item pl-3 pr-5">
                            <div>Developer H2H</div>
                        </router-link>
                    </li> -->
                </ul>
            </div>
            <div class="section full mt-1">
                <div
                    class="listview-title pl-3 pr-3"
                    style="font-weight: bold; font-size: 16px"
                >
                    Keamanan
                </div>
                <ul class="listview image-listview inset">
                    <li>
                        <a class="item" @click="messagePhoneClick()">
                            <div class="in">
                                <div>Nomor HP</div>
                                <span class="text-primary text-right">{{
                                    phone
                                }}</span>
                            </div>
                        </a>
                    </li>
                    <li>
                        <router-link
                            :to="{ name: 'account.email' }"
                            class="item"
                        >
                            <div class="in">
                                <div>Alamat Email</div>
                                <span
                                    class="text-primary text-right"
                                    v-if="
                                        customer.email == null ||
                                        customer.email_verified == null
                                    "
                                    >Belum Diatur</span
                                >
                            </div>
                        </router-link>
                    </li>
                    <li>
                        <router-link :to="{ name: 'account.pin' }" class="item">
                            <div class="in">
                                <div>PIN Keamanan</div>
                            </div>
                        </router-link>
                    </li>
                    <!-- <li>
            <router-link :to="{ name: 'account.question' }" class="item">
              <div class="in">
                <div>Pertanyaan Keamanan</div>
              </div>
            </router-link>
          </li> -->
                </ul>
            </div>

            <div class="section full mt-1 mb-2">
                <div
                    class="listview-title pl-3 pr-3"
                    style="font-weight: bold; font-size: 16px"
                >
                    Lainnya
                </div>
                <ul class="listview image-listview inset">
                    <li>
                        <a
                            :href="
                                'https://play.google.com/store/apps/details?id=' +
                                VUE_ENV.VUE_APP_PACKAGENAME_APK
                            "
                            target="_blank"
                            class="item"
                        >
                            <div class="in">
                                <div>Beri Penilaian Aplikasi</div>
                            </div>
                        </a>
                    </li>
                    <li>
                        <router-link :to="{ name: 'care-center' }" class="item">
                            <div class="in">
                                <div>Hubungi Kami</div>
                            </div>
                        </router-link>
                    </li>
                    <!-- <li>
                        <router-link :to="{name: 'about'}" class="item">
                            <div class="icon-box bg-primary">
                                <ion-icon name="business"></ion-icon>
                            </div>
                            <div class="in">
                                <div>Tentang {{ VUE_ENV.VUE_APP_NAME }}</div>
                            </div>
                        </router-link>
                    </li> -->
                    <!-- <li>
                        <router-link :to="{name: 'faq'}" class="item">
                            <div class="icon-box bg-primary">
                                <ion-icon name="information"></ion-icon>
                            </div>
                            <div class="in">
                                <div>FAQ</div>
                            </div>
                        </router-link>
                    </li> -->
                    <li>
                        <router-link :to="{ name: 'tos.data' }" class="item">
                            <div class="in">
                                <div>Syarat & Ketentuan</div>
                            </div>
                        </router-link>
                    </li>
                    <!-- <li>
                        <router-link :to="{name: 'privacy'}" class="item">
                            <div class="icon-box bg-primary">
                                <ion-icon name="information"></ion-icon>
                            </div>
                            <div class="in">
                                <div>Kebijakan Privasi</div>
                            </div>
                        </router-link>
                    </li> -->
                </ul>
            </div>
            <div class="section mt-1 mb-2">
                <button
                    type="button"
                    class="btn btn-outline-danger btn-lg btn-block"
                    @click="showDialog('show')"
                >
                    Keluar
                </button>
            </div>
            <div class="section text-center" v-if="customer.safe == 'YES'">
                <router-link
                    :to="{ name: 'account.delete.info' }"
                    class="text-primary"
                    style="font-size: 12px; font-weight: bold"
                    >Hapus Akun</router-link
                >
            </div>
            <div class="section text-center mt-4 mb-4">
                <img
                    class="w-25"
                    :src="require('@/assets/image/logo_header_color.png')"
                />
                <p style="font-size: 13px; line-height: normal">
                    [ ] Dengan
                    <ion-icon name="heart" style="color: #f24141"></ion-icon> di
                    Indonesia
                </p>
            </div>
        </div>

        <Dialog
            ref="dialog"
            :loading="dialogLoading"
            :title="'Keluar'"
            @confirm="btnLogout()"
        >
            Anda yakin ingin keluar?
        </Dialog>
    </div>
</template>
<script>
    import { mapState, mapActions } from 'vuex';
    export default {
        name: 'account',
        data() {
            return {
                dialogLoading: false,
            };
        },
        computed: {
            ...mapState(['customer', 'toast', 'loading', 'VUE_ENV']),
            phone: function () {
                if (this.customer.phone) {
                    return (
                        this.customer.phone.substring(0, 4) +
                        ' ••••• ' +
                        this.customer.phone.substring(9, 12)
                    );
                } else {
                    return this.customer.phone;
                }
            },
            email: function () {
                if (this.customer.email) {
                    const email = this.customer.email.split('@');
                    return email[0].substring(0, 1) + ' ••••• @' + email[1];
                } else {
                    return this.customer.email;
                }
            },
        },
        methods: {
            ...mapActions(['getCustomer', 'coming']),
            ...mapActions('auth', ['logout']),
            showDialog(value) {
                let element = this.$refs.dialog.$el;
                window.$(element).modal(value);
            },
            btnLogout() {
                this.dialogLoading = true;
                this.logout().then(() => {
                    this.dialogLoading = false;
                    this.showDialog('hide');
                    this.$router.push({ name: 'auth.login' });
                });
            },
            onClickVeryButton() {
                this.loading.app = true;
                this.getCustomer().then(response => {
                    this.loading.app = false;
                    if (
                        response.data.account_verified_status == false ||
                        response.data.account_verified_status == 'REJECTED'
                    ) {
                        if (typeof window.AndroidNative !== 'undefined') {
                            window.AndroidNative.showFormVerification();
                        } else {
                            this.$store.commit('SET_TOAST', {
                                show: true,
                                message:
                                    'Fitur ini hanya bisa digunakan melalui aplikasi',
                                tipe: 'default',
                                icon: 'warning',
                            });
                        }
                    } else if (
                        response.data.account_verified_status == 'PROCESS'
                    ) {
                        this.$store.commit('SET_TOAST', {
                            show: true,
                            message:
                                'Masih dalam proses verifikasi data, proses ini memberlukan waktu maksimal 1x24 jam (tidak termasuk hari sabtu, minggu dan hari libur nasional)',
                            tipe: 'default',
                            icon: 'warning',
                        });
                    } else if (
                        response.data.account_verified_status == 'APPROVED'
                    ) {
                        this.$store.commit('SET_TOAST', {
                            show: true,
                            message: 'Data diri telah berhasil terverifikasi',
                            tipe: 'default',
                            icon: 'success',
                        });
                    }
                });
            },
            GoToVerified() {
                this.$router.push({ name: 'account.data-diri' });
            },
            messagePhoneClick() {
                this.$store.commit('SET_TOAST', {
                    show: true,
                    message: 'Nomor HP tidak dapat diubah',
                    tipe: 'default',
                    icon: 'warning',
                });
            },
        },
        mounted() {
            this.getCustomer();
        },
        destroyed() {
            this.$store.commit('RESET_LOADING');
            this.$store.commit('RESET_TOAST');
        },
    };
</script>
